module.exports = __webpack_public_path__ + "images/d7e8896a8f755a86e65bcb21581fbbb6-Visit_California_logo.png";